export default __webpack_public_path__ + "static/media/edit.6d257bd0.svg";